import { render, staticRenderFns } from "./RotatingImage.vue?vue&type=template&id=63696fa0&scoped=true"
import script from "./RotatingImage.vue?vue&type=script&lang=js"
export * from "./RotatingImage.vue?vue&type=script&lang=js"
import style0 from "./RotatingImage.vue?vue&type=style&index=0&id=63696fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63696fa0",
  null
  
)

export default component.exports